module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.screen < 2) ? _c('add-users-steps-bar', {
    attrs: {
      "stepActive": _vm.stepActive
    },
    on: {
      "nextScreen": _vm.nextScreen
    }
  }) : _vm._e(), _vm._v(" "), (_vm.screen === 1) ? _c('add-courses-upload-csv') : (_vm.screen === 2) ? _c('add-users-third-step') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2a8acaea!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/courses/addCourses/adminPortalAddCourses.vue
// module id = 2096
// module chunks = 61